export { SharedAuthenticationAuthenticationModule } from './lib/shared-authentication-data-access.module';
export { AuthService } from './lib/auth.service';
export { Token } from './lib/models/token';
